import { render, staticRenderFns } from "./avisos.vue?vue&type=template&id=5086cd9c"
import script from "./avisos.vue?vue&type=script&lang=js"
export * from "./avisos.vue?vue&type=script&lang=js"
import style0 from "./avisos.vue?vue&type=style&index=0&id=5086cd9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports